import { useEffect } from 'react';
import { Sidebar } from '../SideBar';
import classNames from 'clsx';
import { TopAvatar } from '../TopAvatar';
import { TitleContainer } from '../HeaderTitle';

import { BreadcrumbsContainer } from '../Breadcrumbs/Breadcrumbs';
import { useAppContext, useUserContext } from '../../context';
import { PageHelpContainer } from '../PageHelp/PageHelp';

export const Layout: React.FC = ({ children }) => {
  const { isInited, currentOrg } = useUserContext();
  const { sidebarCollapsed, setPresentationMode } = useAppContext();
  const isDemoAccount = currentOrg?.refId === 'DMO';

  useEffect(() => {
    if (isDemoAccount) {
      setPresentationMode(true);
    }
  }, [isDemoAccount, setPresentationMode]);

  return (
    <div className="flex flex-col h-screen">
      {isDemoAccount && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-red-100 text-black text-center py-2 font-medium">
          This is a demo account with mock data for training and demo purposes
        </div>
      )}
      <div
        className={classNames('flex justify-between bg-athensGrey flex-1 transition-all', {
          'mt-10': isDemoAccount,
        })}
      >
        <div className="ml-4 mt-4 mb-4 min-h-[70rem]">{isInited ? <Sidebar /> : null}</div>
        <div
          className={classNames('flex flex-col', {
            'w-[calc(100vw-110px)]': sidebarCollapsed,
            'xl:w-[calc(100vw-240px)] lg:w-[calc(100vw-220px)] md:w-[calc(100vw-200px)]':
              !sidebarCollapsed,
          })}
        >
          <div className="page-head flex justify-between mt-2 mb-2 mx-12 h-[9.5rem]">
            <div className="headcontainer">
              <BreadcrumbsContainer />
              <div className="pagetitle mt-7 mb-8">
                <TitleContainer />
              </div>
            </div>
            <div className="useraction flex items-center">
              <PageHelpContainer />
              <div className="userselectbox">
                <TopAvatar />
              </div>
            </div>
          </div>
          {/* {!!isInited && <div className="h-px bg-gray-400 bg-opacity-[0.15] mx-12"></div>} */}
          <div className="flex flex-col flex-grow overflow-y-auto px-12 pb-12">
            {isInited ? children : null}
          </div>
        </div>
      </div>
    </div>
  );
};
